import { getStorageURL } from 'helpers/getStorageURL';
import { v4 as uuid } from 'uuid';
export const addUrl = ( url ) => {
  let urlInfo = new URL(url);
  let filename = urlInfo.pathname.split('/').reverse()[0]
  let ext = filename.split('.').pop();
  return addThumbnails({
    id: uuid(),filename,
    url,
    ext
  })
}
export const uploadFile = (file: File) => {
  return new Promise<Attachment>((resolve, reject) => {
    const id = uuid();
    fetch(getStorageURL(), {
      method: 'POST',
      headers: {
        'x-filename': file.name.replace(/[^\x00-\xFF]/g, ""),
        'x-expires': '30', // expires in 30 minutes
        'x-key': id,
      },
      body: file,
    })
      .then((result) => result.json())
      .then((result) => {
        resolve({
          id,
          ...addThumbnails(result),
          type: result?.type ? result.type : file.type,
        } as Attachment);
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.log('ERROR ON UPLOAD', err, err.toString());
        reject(err);
      });
  });
};

export const addThumbnails = (attachment: Attachment): Attachment => {
  if (attachment.thumbnails) {
    return attachment;
  }
  return {
    ...attachment,
    thumbnails: {
      full: {
        url: attachment.url,
      },
    },
  } as Attachment;
};
